import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { Guid } from 'guid-typescript';
import $ from 'jquery';
import { Course, Page, Topic, UserDashboard, UserTopics, UserTopicStatus } from '../app.models';
import { AppService } from '../app.service';
import { SafeHtmlPipe } from '../templates/safe.pipe';

@Component({
  selector: 'app-topic',
  templateUrl: './topic.component.html',
  styleUrls: ['./topic.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe],
})
export class TopicComponent implements OnInit {
  isTopicDataLoaded: boolean = false;
  course = new Course();
  userDashboard = new UserDashboard();
  firstName: string = '';
  lastName: string = '';
  emailAddress: string = '';
  mbtiType: string = '';
  htmlString: string = '';

  public courseName: string = '';
  public courseId: Guid = Guid.createEmpty();
  public topicId: string = '';
  public nextTopicName: string = '';
  public topics: Topic[] = [];
  public totalTopics: number = 0;
  public totalPages: number = 0;
  public currentTopic = new Topic();
  public percentageCompleted: string = '';
  public lastPageVisited: number = 0;
  public pages: Page[] = [];
  public userTopicsStatus: UserTopicStatus[] = [];

  Http: HttpClient;
  HttpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(
    private appService: AppService,
    http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.Http = http;
    // override the route reuse strategy
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    this.mbtiType = this.appService.mbtiType;

    this.route.queryParams.subscribe((params) => {
      this.courseId = params['courseId'];
      this.topicId = params['topicId'];

      if (!this.courseId) {
        this.router.navigate(['/learn']);
      }

      if (!this.topicId) {
        //Default first topic
        this.topicId = 'T1';
      }

      this.appService.getCourse(this.courseId).subscribe(
        (result) => {
          if (result != null) {
            this.course = result;
            this.topics = this.course.topics;
            this.totalTopics = this.course.numTopics;
            this.currentTopic = this.course.topics.find((item) => item.topicId == this.topicId) || new Topic();
            this.totalPages = this.currentTopic.numPages;

            for (var page of this.currentTopic.pages) {
              var newPage = new Page();
              newPage.html = page.html;
              newPage.pageId = page.pageId;
              newPage.pageTitle = page.pageTitle;
              newPage.pageNumber = page.pageNumber;
              newPage.percentageCompleted = (page.pageNumber / this.totalPages) * 100;
              newPage.show = false;
              this.pages.push(newPage);
            }

            if (this.currentTopic.topicNumber < this.totalTopics) {
              let _nextTopicId = 'T' + (this.currentTopic.topicNumber + 1).toString();
              let nextTopic = this.course.topics.find((item) => item.topicId == _nextTopicId);
              let _nextTopicName = nextTopic ? nextTopic.topicName : '';
              this.nextTopicName = _nextTopicName === '' ? 'Next' : 'Next: ' + _nextTopicName;
            } else if (this.currentTopic.topicNumber === this.totalTopics) {
              this.nextTopicName = 'Return to Course';
            } else {
              this.nextTopicName = 'Next';
            }

            //Get the user course topic status
            this.Http.get<UserTopics>('/api/user/usercoursetopics/' + this.courseId).subscribe(
              (data) => {
                if (data == null) {
                  //Insert into user topics if no record exists or first time user for this course
                  for (var topic of this.course.topics) {
                    var userTopicStatus = new UserTopicStatus();
                    userTopicStatus.topicId = topic.topicId;
                    userTopicStatus.lastPageVisited = 0;
                    this.userTopicsStatus.push(userTopicStatus);
                  }

                  var param = { CourseId: this.courseId, UserTopicsStatus: this.userTopicsStatus };
                  this.Http.post('/api/user/usercoursetopics', param, this.HttpOptions).subscribe(
                    () => {},
                    (error) => {
                      this.appService.handleError(error);
                    },
                  );
                } else {
                  //Update course topic last visited page to reflect the current status.
                  this.userTopicsStatus = data.userTopicsStatus;
                  this.updateCourseTopicsCurrentStatus(this.userTopicsStatus);

                  const topicStatus = this.userTopicsStatus.find((t) => t.topicId === this.topicId);
                  this.lastPageVisited = topicStatus ? topicStatus.lastPageVisited : 0;

                  // if you have never viewed the topic, or viewed all pages in the topic, take them to the first page
                  if (this.lastPageVisited === 0 || this.lastPageVisited === this.totalPages) this.lastPageVisited = 1;

                  // Subtract 1 because array starts at 0
                  this.pages[this.lastPageVisited - 1].show = true;

                  this.appService.loadScript('../assets/js/course.js');
                  this.isTopicDataLoaded = true;
                }
              },
              (error) => {
                this.appService.handleError(error);
              },
            );
          } else {
            this.router.navigate(['/learn']);
          }
        },
        (error) => {
          this.appService.handleError(error);
          this.isTopicDataLoaded = true;
        },
      );
    });
  }

  private updateCourseTopicsCurrentStatus(userTopicsStatus: UserTopicStatus[]) {
    for (var topic of this.course.topics) {
      let topicStatus = userTopicsStatus.find((item) => item.topicId == topic.topicId);
      let topicLastPageCompleted = topicStatus ? topicStatus.lastPageVisited : 0;
      if (topicLastPageCompleted == topic.numPages && topic.topicCompleted != true) {
        topic.topicCompleted = true;
      }
      topic.lastPageVisited = topicLastPageCompleted;
    }
    //Set course completed flag to true if all topics are completed.
    //this.course.isCompleted = (this.course.topics.find(x => x.topicCompleted==false) != null) ?
  }

  public close() {
    this.router.navigate(['/course'], { queryParams: { courseId: this.courseId } });
  }

  public saveAndClose(currentPageNumber: number) {
     this.save(currentPageNumber).subscribe(() => {
        this.router.navigate(['/course'], { queryParams: { courseId: this.courseId } });
     },
     (error) => {
        this.appService.handleError(error);
     });
  }

  public previous(currentPage: Page) {
      let currentPageNumber = currentPage.pageNumber;
      this.save(currentPageNumber).subscribe(() => {
         if (currentPageNumber === 1) {
            // We are on the first page in that topic
            this.router.navigate(['/course'], { queryParams: { courseId: this.courseId } });
         }
         else {
            currentPage.show = false;
            this.pages[currentPageNumber - 2].show = true;    // Because arrays start at 0
            $(window).scrollTop(0);
         }
      },
      (error) => {
         this.appService.handleError(error);
      });

      return false;
  }

  public next(currentPage: Page) {
      let currentPageNumber = currentPage.pageNumber;
      this.save(currentPageNumber).subscribe(() => {
         if (currentPageNumber < this.totalPages) {
            // Still in the current topic
            currentPage.show = false;
            this.pages[currentPageNumber].show = true;   // Because arrays start at 0
            $(window).scrollTop(0);
         }
         else {
            // We are on the last page in that topic
            var nextTopicId;
            var currentTopicNumber = this.topics.find(t => t.topicId == this.topicId).topicNumber;

            //If all the topics are done, then go to course landing page.
            if (currentTopicNumber == this.totalTopics) {
               //Go to course landing
               this.router.navigate(['/course'], { queryParams: { courseId: this.courseId } });
            }
            else {
               nextTopicId = 'T' + (currentTopicNumber + 1);
               this.router.navigate(['/topic'], { queryParams: { courseId: this.courseId, topicId: nextTopicId } });
            }
         }
      },
      (error) => {
         this.appService.handleError(error);
      });

      return false;
  }

   private save(currentPageNumber: number): Observable<Object> {
      for (var topic of this.userTopicsStatus) {
         if (topic.topicId == this.topicId) {
            if (topic.lastPageVisited <= currentPageNumber)
               topic.lastPageVisited = currentPageNumber;
         }
      }
      
      var param = { CourseId: this.courseId, UserTopicsStatus: this.userTopicsStatus };
      return this.Http.put('/api/user/usercoursetopics', param, this.HttpOptions);
  }
}
